module.exports = __webpack_public_path__ + "img/crypto.e136264e.svg";